import { useStateDataGrid } from 'features/shared/components/dataGrid/hooks/useStateDataGrid';
import { loadDataFilterConfig } from 'features/shared/helpers/modules';
import React from 'react';
import { usePaymentsOnDetail } from 'features/payments/hooks/usePaymentsOnDetail';
import DataGridRow from 'features/shared/components/dataGrid/DataGridRow';
import Payment from 'features/payments/components/Payment';
import NoContentWrapper from 'features/shared/components/noContentWrapper/NoContentWrapper';
import DataGridHeader from 'features/shared/components/dataGrid/DataGridHeader';
import PaymentHeader from 'features/payments/components/PaymentHeader';
import DataFilterModal from 'features/shared/components/dataFilterModal/DataFilterModal';
import Pagination from 'features/shared/components/pagination/Pagination';
import { useTranslation } from 'react-i18next';

const paymentsDataFilterJson = loadDataFilterConfig("paymentsDataFilter");
const pageSize = 10;

interface Props {
  filterByName: string;
  filterByValue: string;
  proformaInvoiceId?: string;
}

const PaymentsOnDetailSection = ({ filterByName, filterByValue, proformaInvoiceId }: Props) => {
  // translations
  const tLabels = useTranslation("payments\\payments").t;
  
  // data grid hook
  const {
    dataGrid,
    descriptors,
    setDescriptors,
    showFilter,
    setShowFilter,
    paginationPageChangeHandler,
    filterApplyHandler,
    filterResetHandler,
    isApplyFilter,
    conditionalRefresh,
  } = useStateDataGrid(pageSize, paymentsDataFilterJson);

  // fetch payment data hook
  const {
    payments,
    paymentsLoadStatus,
    externalFilterData: paymentseEternalFilterData,
  } = usePaymentsOnDetail(
    filterByName,
    filterByValue,
    dataGrid.computedUrlSearchParams,
    conditionalRefresh,
    proformaInvoiceId
  );

  //sub-renders
  const renderpayments = () => {
    return payments.result.map((item) =>
      <DataGridRow key={item.paymentId}>
        <Payment payment={item} />
      </DataGridRow>
    );  
  } 

  //render
  return (
    <NoContentWrapper
      data={payments}
      loadStatus={paymentsLoadStatus}
      noContentAsAlert
      isActiveFilter={isApplyFilter}
      noContentInfo={tLabels("paymentsOnDetailSection.noPaymentsFound")}
    >
      <DataGridHeader 
        count={payments.count}
        setShowFilterModal={setShowFilter}
        filterActive={isApplyFilter()}
      />
      <PaymentHeader />
      {renderpayments()}
      <div className="d-flex justify-content-center mt-4">
        <Pagination
          urlParams={new URLSearchParams(dataGrid.computedUrlSearchParams)}
          count={payments.count!}
          pageSize={pageSize}
          onPageChange={paginationPageChangeHandler}
        />
      </div>

      <DataFilterModal
        descriptors={descriptors}
        externalData={paymentseEternalFilterData}
        setDescriptors={setDescriptors}
        applyButtonOnClick={filterApplyHandler}
        resetButtonOnClick={filterResetHandler}
        show={showFilter}
        setShow={setShowFilter}
      />
    </NoContentWrapper>
  );
}

export default PaymentsOnDetailSection;